import { useTranslation } from 'react-i18next'
import { MessageSquare }  from 'lucide-react'
import { PageHeader, Card } from '@/components/ui/primitives'

export default function ForumPage() {
  const { t } = useTranslation()
  return (
    <div className="space-y-6">
      <PageHeader
        title={t('nav.forum')}
        subtitle="Discussion boards and Q&A"
      />
      <Card>
        <div className="flex flex-col items-center justify-center py-16 text-center">
          <MessageSquare size={48} className="text-emerald-400 mb-4" />
          <h3 className="font-semibold text-white/72 mb-1">Forum coming soon</h3>
          <p className="text-sm text-white/45 max-w-xs">
            A threaded discussion forum for students and teachers will be available here.
          </p>
        </div>
      </Card>
    </div>
  )
}

